(function() {
    var m = angular.module('callback', ['utils']);

    m.controller('CallbackCtrl', ['$scope', '$http', '$window', function($scope, $http, $window) {
        $scope.form = CALLBACK_FORM;

        $scope.fields = {
            name: getProfileProperty('name'),
            phone: getProfileProperty('phone'),
            callFrom: null,
            callTo: null,
            agree: false
        };

        $scope.callFromTime = [];
        $scope.callToTime = [];
        $scope.dayOfWeek = 0;

        // Callback order flag
        $scope.isOrdered = false;

        /**
         * Updates call-from and call-to time lists
         *
         * @param from Start hour in MSK
         * @param to   End hour in MSK
         */
        $scope.updateHoursList = function (from, to) {
            var now = new Date(),
                day = now.getDay(), // Day of week [1..7]
                minHour = 8,        // Working MSK hours for office
                maxHour = 20,
                minLocalHour = 8,   // Minimum and maximum local call hours
                maxLocalHour = 20,
                timezoneOffset = 0, // MSK timezone offset - local timezone offset
                hour = (day == 7 || day == 6)
                    ? minHour                // Sunday and saturday are non-working days and calls will be made at monday
                    : now.getUTCHours() + 3; // Hour in MSK timezone
            $scope.dayOfWeek = day;

            // Filter incorrect data
            if (hour >= maxHour || hour < minHour) {
                hour = minHour;
            }
            if (!from || from < hour || from >= maxHour) {
                from = hour;
            }
            if (!to || to > maxHour || to <= hour) {
                to = maxHour;
            }
            if (from >= to) {
                from = to - 1;
            }

            // Fill lists with new items
            $scope.callFromTime = [];
            $scope.callToTime = [];
            var localHour;

            for (
                localHour = Math.max(hour + timezoneOffset, minLocalHour);
                localHour < Math.min(to + timezoneOffset, maxLocalHour);
                localHour++
            ) {
                $scope.callFromTime.push(localHour);
            }

            for (
                localHour = Math.max(from + 1 + timezoneOffset, minLocalHour);
                localHour <= Math.min(maxHour + timezoneOffset, maxLocalHour);
                localHour++
            ) {
                $scope.callToTime.push(localHour);
            }

            // Update target fields
            $scope.fields.callFrom = Math.max(from + timezoneOffset, minLocalHour);
            $scope.fields.callTo   = Math.min(to + timezoneOffset, maxLocalHour);
        };

        // Initialize call from and call to time lists
        $scope.updateHoursList(8, 20);

        /**
         * @todo move to some other file. dup code
         * @type {Object}
         */
        var groupsDirty = {};
        var watchDirtyFields = [
            'agree'
        ];

        /**
         * @todo move to some other file. dup code
         */
        $scope.$watchGroup(watchDirtyFields.map(function(item) {
            return 'fields.' + item;
        }), function(groups) {
            for (var i in groups) {
                if (groups[i]) {
                    groupsDirty[watchDirtyFields[i]] = true;
                }
            }
        });

        /**
         * @todo move to some other file. dup code
         */
        function getProfileProperty(field) {
            var profile = $scope.form.profile;

            return profile && profile[field] ? profile[field] : null;
        }

        $scope.groupValidationClass = function(fieldName) {
            var control = $scope.callbackForm[fieldName];

            return {
                'ng-invalid': control.$invalid,
                'ng-dirty': groupsDirty[fieldName]
            };
        };

        $scope.submitErrorList = [];
        $scope.submitErrors = function() {
            return $scope.submitErrorList.join('<br>');
        };

        $scope.submit = function() {
            if (!$scope.callbackForm.$valid) {
                $scope.submitErrorList = ['Перед отправкой заявки необходимо правильно заполнить поля, выделенные красным'];
                $scope.$emit('submitErrorEvent');
                return;
            }
            var name = $scope.fields.name.split(' ');
            if (name.length < 2 || !name[0].length || !name[1].length) {
                $scope.submitErrorList = ['Необходимо указать имя и фамилию'];
                $scope.$emit('submitErrorEvent');
                return;
            }

            $scope.isLoading = true;

            var postData = {
                Profiles: {
                    name: $scope.fields.name,
                    phone: $scope.fields.phone
                },
                callFrom: $scope.fields.callFrom,
                callTo: $scope.fields.callTo,
                UrlParameters: document.getElementById('urlParameters').getAttribute('value')
            };

            $http.post(
                $scope.form.url,
                postData
            ).then(
                function(response) {
                    var data = response.data;
                    if (data.errors instanceof Array && data.errors.length == 0) {
                        //$window.location.href = $scope.form.redirectUrl;
                        $scope.isOrdered = true;
                        $scope.isLoading = false;
                    } else {
                        // @todo: add logging to server
                        $scope.submitErrorList = ['Произошла ошибка отправки, попробуйте еще раз немного позже.<br/>Если ошибка повторяется, напишите нам на <a href="mailto:info@escc.ru">info@escc.ru</a>'];
                        $scope.$emit('submitErrorEvent');
                    }

                },
                function() {
                    // @todo: add logging to server
                    $scope.submitErrorList = ['Произошла ошибка отправки, попробуйте еще раз немного позже. Если ошибка повторяется, напишите нам на <a href="mailto:info@escc.ru">info@escc.ru</a>'];
                    $scope.$emit('submitErrorEvent');
                }
            );
        };
    }]);
})();
